import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const LaborWaitingBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-sky-500 font-semibold text-white">
      {t('component:badge.waitingPhase')}
    </Badge>
  );
};
